import { server_ip } from "../config";


async function deleteWorkOrder(token,_id) {
    try {
        const response = await fetch(`${server_ip}/api/workOrders/${_id}`, {
            method: 'DELETE',
            headers: {
                Accept: '/',
                Authorization: `Bearer ${token}`,
            },
        })
        return await response.json();
    } catch (error) {
        console.log(JSON.stringify(error));
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}
async function postCreateWorkOrder(token,data) {
    try {
        const response = await fetch(`${server_ip}/api/workOrders/`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                data
            }),
        })
        return await response.json();
    } catch (error) {
        console.log(JSON.stringify(error));
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}
async function putEditWorkOrder(token,data,_id) {
    try {
        const response = await fetch(`${server_ip}/api/workOrders/${_id}`, {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                data
            }),
        })
        return await response.json();
    } catch (error) {
        console.log(JSON.stringify(error));
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}
async function fetchWorkOrder(token, filter={}, options={}) {
    try {
        const response = await fetch(`${server_ip}/api/workOrders/fetch`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                filter,
                options
            })
        })
        return await response.json();
    } catch (error) {
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}
async function fetchWorkOrderById(token,id) {
    try {
        const response = await fetch(`${server_ip}/api/workOrders/${id}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        })
        return await response.json();
    } catch (error) {
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}


async function fetchWorkOrderPieChartStats(token, filter){
    try {
        const response = await fetch(`${server_ip}/api/workOrders/statistic`,{
            method:'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',  
                Authorization: `Bearer ${token}`,    
 
            },
            body: JSON.stringify({
                "filter":{...filter},
                "options":{}
            })
        })
        return await response.json();
    } catch (error) {
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}

export{
    postCreateWorkOrder,
    fetchWorkOrder,
    putEditWorkOrder,
    deleteWorkOrder,
    fetchWorkOrderById,
    fetchWorkOrderPieChartStats,
}